import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../../Styles/Partials/DefaultDisplay.css';
import '../../Styles/Layout/InputArea.css';
import { useWindow } from '../../contexts/WindowContext';
import { getRandomHeader } from '../../helpers/chatHelper';
import { useChatContext } from '../../contexts/AppDataContext';

interface DefaultDisplayProps {
  InputArea: React.ReactNode;
  isSubmitting: boolean;
}

export const DefaultDisplay: React.FC<DefaultDisplayProps> = ({
  InputArea,
  isSubmitting
}) => {
  const auth = useAuth();
  const { windowWidth } = useWindow();
  const { isIncognito } = useChatContext();
  const [dynamicHeader, setDynamicHeader] = useState({
    greeting: '',
    subtext: ''
  });

  useEffect(() => {
    setDynamicHeader(getRandomHeader(auth.user?.name ?? ''));
  }, [auth.user?.name]);


  if(isSubmitting) { return null; }

  return (
    <div className={`default-display ${auth.isAuthenticated ? '' : 'guest-display'}`}>
      <div className="welcome-container">
        <h1 className={`dynamic-header ${isIncognito ? 'incognito' : ''}`}>{isIncognito ? 'Private Chat' : dynamicHeader.greeting}</h1>
        {isIncognito && (
          <p className="dynamic-subtext">
            This chat won't be saved and isn't shaped by your past conversations or memory.
          </p>
        )}
      </div>

      {windowWidth > 600 && (
        <div className={`input-container default`}>
          {InputArea}
        </div>
      )}

    </div>
  );
};
